import {
  Linkedin,
  CheckCircle,
  Settings,
  Brain,
  Headphones,
} from "lucide-react";

import { Button } from "@/shadcnComponents/ui/button";
import { useCallback, useEffect, useState } from "react";
import { useInfluencer } from "@/Providers/Influencer";
import { formatFollowersCount } from "@/Helpers/format-helper";
import { useAuth } from "@/Providers/Auth";
import { useNavigate } from "react-router-dom";
import mixpanel from "mixpanel-browser";

export default function InfluencerSignupPage() {
  const influencerState = useInfluencer();
  const navigate = useNavigate();
  const authState = useAuth();

  const [topInfluencer, setTopInfluencer] = useState([]);

  const getFeaturedCreators = useCallback(async () => {
    const result = await influencerState?.getFeaturedCreators();
    if (result?.success) {
      setTopInfluencer(result?.topInfluencer);
    } else {
      console.log("Some Error Occurred!");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleLinkedInLogin = async () => {
    if (authState?.loggedUser) {
      mixpanel.track("Clicked on my account");
      navigate(`/influencer/dashboard`);
    } else {
      localStorage.setItem("from", "linkedin");
      localStorage.setItem("authFor", "login");
      mixpanel.track("Linkedin Login Main page");
      authState?.handleOpenLinkedin({});
    }
  };

  useEffect(() => {
    getFeaturedCreators();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="dark min-h-screen bg-slate-950">
      {/* Main Container */}
      <div className="mx-auto w-full md:w-[80%]">
        {/* Header - Always at top */}
        <header className="w-full border-b border-slate-800 bg-slate-950 p-4 md:p-6">
          <img
            src="https://anchors-assets.s3.ap-south-1.amazonaws.com/anchors+logo+with+white+text.png"
            alt="Anchors Collab"
            className="w-32 md:w-44 cursor-pointer"
          />
        </header>

        <div className="flex flex-col md:flex-row">
          {/* Right Section - First on mobile, right on desktop */}
          <div className="order-1 flex min-h-[70vh] w-full items-center justify-center bg-slate-950 p-6 md:order-2 md:min-h-0 md:w-1/2 md:p-10">
            <div className="mx-auto w-full max-w-md">
              <div className="mb-8 text-center">
                <h1 className="mb-2 text-3xl font-bold text-white">
                  Welcome to anchors
                </h1>
                <p className="text-slate-400">
                  Grow, network & monetize. All in one place.
                </p>
              </div>

              <Button
                onClick={() => {
                  handleLinkedInLogin();
                }}
                className="mb-4 flex w-full items-center justify-center gap-2 bg-red-500 py-6 text-white hover:bg-red-600"
              >
                {authState?.loggedUser ? (
                  "Go to my account →"
                ) : (
                  <>
                    <Linkedin className="h-5 w-5" />
                    Continue with LinkedIn
                  </>
                )}
              </Button>

              <div className="text-center">
                <p className="mb-4 text-xs text-slate-400">
                  By continuing, you agree to our{" "}
                  <span
                    onClick={() =>
                      window.open(
                        "https://www.anchors.in/termsConditions",
                        "_blank"
                      )
                    }
                    className="underline cursor-pointer"
                  >
                    T&C's
                  </span>{" "}
                  and{" "}
                  <span
                    onClick={() =>
                      window.open(
                        "https://www.anchors.in/privacy-policy",
                        "_blank"
                      )
                    }
                    className="underline cursor-pointer"
                  >
                    Privacy Policy
                  </span>
                </p>

                <div className="mt-6 flex flex-col items-center">
                  <div className="flex -space-x-3">
                    {InfluencerImages?.slice(0, 3).map((item, index) => {
                      return (
                        <div
                          key={`topInfluencer_${index}`}
                          className="relative h-10 w-10 overflow-hidden rounded-full border-2 border-slate-800"
                        >
                          <img
                            src={item}
                            alt={`Influencer ${index}`}
                            title={`Influencer ${index}`}
                            width={40}
                            height={40}
                            className="h-full w-full object-cover"
                          />
                        </div>
                      );
                    })}
                  </div>
                  <p className="mt-2 text-sm font-medium text-white">
                    1000+ creators onboard
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Left Section - Second on mobile, left on desktop */}
          <div className="order-2 w-full bg-slate-950 p-6 md:order-1 md:w-1/2 md:p-10">
            <div className="mb-8">
              <h2 className="mb-6 text-2xl font-bold text-white">
                Influencers of the Week
              </h2>
              <div className="overflow-hidden">
                <div className="animate-scroll flex w-max gap-4 pb-4">
                  {/* Double the influencers array to create a seamless loop */}
                  {[...topInfluencer, ...topInfluencer].map(
                    (influencer, index) => (
                      <div
                        key={index}
                        className="relative flex-none rounded-xl bg-slate-800 shadow-md"
                        style={{ width: "140px", height: "180px" }}
                      >
                        <img
                          src={influencer.profile || "/placeholder.svg"}
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null; // prevents looping
                            currentTarget.src =
                              "https://collab.anchors.in/FeatredCreatorBackground.png";
                          }}
                          alt={influencer.name}
                          width={140}
                          height={180}
                          className="h-full w-full rounded-xl object-cover"
                        />
                        <div className="absolute bottom-0 w-full rounded-b-xl bg-black/70 p-2 text-white">
                          <h3 className="text-sm line-clamp-1 font-medium">
                            {influencer.name}
                          </h3>
                          <div className="flex items-center gap-1">
                            <Linkedin className="h-3 w-3" />
                            <p className="text-xs">
                              {formatFollowersCount(
                                parseInt(influencer.followers?.replace(",", ""))
                              ) || "71k"}
                            </p>
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>

            <div className="mb-8">
              <h2 className="mb-4 text-xl font-bold text-white">
                Why anchors?
              </h2>
              <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                <div className="flex items-start gap-2.5 rounded-lg bg-slate-800/50 p-3">
                  <CheckCircle className="mt-0.5 h-4 w-4 text-red-500" />
                  <div>
                    <h3 className="text-sm font-medium text-white">
                      No Negotiations
                    </h3>
                    <p className="text-xs text-slate-400">
                      Fair, transparent payouts
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-2.5 rounded-lg bg-slate-800/50 p-3">
                  <Settings className="mt-0.5 h-4 w-4 text-red-500" />
                  <div>
                    <h3 className="text-sm font-medium text-white">
                      No Ghosting
                    </h3>
                    <p className="text-xs text-slate-400">
                      Brands reach out when ready
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-2.5 rounded-lg bg-slate-800/50 p-3">
                  <Brain className="mt-0.5 h-4 w-4 text-red-500" />
                  <div>
                    <h3 className="text-sm font-medium text-white">
                      Exclusive Community
                    </h3>
                    <p className="text-xs text-slate-400">
                      Connect with top creators
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-2.5 rounded-lg bg-slate-800/50 p-3">
                  <Headphones className="mt-0.5 h-4 w-4 text-red-500" />
                  <div>
                    <h3 className="text-sm font-medium text-white">
                      Deep LinkedIn Insights
                    </h3>
                    <p className="text-xs text-slate-400">
                      Optimize content & reach
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const InfluencerImages = [
  "https://anchors-collab.s3.ap-south-1.amazonaws.com/collabInfluencerProfiles/1728043200441-1727796787932%3Fe%3D1733356800%26v%3Dbeta%26t%3DS_uxFnXezNMbb-cuijr4GgI1AXBQjnED2wAFqmlodnw",
  "https://anchors-collab.s3.ap-south-1.amazonaws.com/collabInfluncer/1727961732632-qivhnpvzry.png",
  "https://anchors-collab.s3.ap-south-1.amazonaws.com/collabInfluncer/1726556436546-fhrddzrwpi.png",
];
